import React from 'react'
import Sidebar from '../Sidebar'
import Navbar from '../Navbar/Navbar'
// import { Outlet } from 'react-router-dom';

const Layout = ({ children }) => {

  return (
    <>
      <div className="layout">
        <Sidebar />
        <div className="content">
          <Navbar />
          <main>{children}</main>
        </div>
      </div>
    </>
  );
};

export default Layout;